<template>
  <div>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline mb-0">{{title}}</h3>
        </v-card-title>
        <v-card-text>
          <!-- -->
          <v-container grid-list-md text-xs-left>
            <v-card color="transparent" flat light>
              <v-card-text class="px-0" v-if="!editExternal">
                <template v-for="item in infoEntity">
                  <v-layout :key="item._id" row wrap>
                    <v-flex xs12 md4 class="body-2">{{item.field}}</v-flex>
                    <v-flex xs12 md8>{{item.data}}</v-flex>
                  </v-layout>
                  <v-divider :key="item._id + 1"></v-divider>
                </template>
                <v-layout>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-spacer></v-spacer>
                    <v-flex d-flex sm4>
                      <v-btn
                        @click="removeForm()"
                        :loading="loading"
                        color="error"
                        v-if="action === 'remove'"
                      >{{$t('delete')}}</v-btn>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-text class="px-0" v-else>
                <v-layout wrap>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <v-switch v-model="entityLocal.active" :label="$t('active')" color="primary"></v-switch>
                    </v-flex>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <v-switch
                        v-model="entityLocal.isCustomer"
                        :label="$t('client')"
                        color="primary"
                      ></v-switch>
                    </v-flex>
                  </v-flex>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <v-text-field
                        v-model="entityLocal.name"
                        :label="$t('name')"
                        :rules="[v => rules.vacio(v,'name')]"
                      ></v-text-field>
                      <!-- <IgTextField
                        :rules="[v => rules.vacio(v,'name')]"
                        :status="status"
                        :label="$t('name')"
                        v-model="entityLocal.name"
                      ></IgTextField>-->
                    </v-flex>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <IgTextField
                        :status="status"
                        :label="$t('siteUrl')"
                        v-model="entityLocal.web"
                      ></IgTextField>
                    </v-flex>
                  </v-flex>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <IgTextField
                        :status="status"
                        :label="$t('phone')"
                        v-model="entityLocal.phone"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></IgTextField>
                    </v-flex>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <IgTextField
                        :rules="[rules.email]"
                        :status="status"
                        :label="$t('email')"
                        v-model="entityLocal.email"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></IgTextField>
                    </v-flex>
                  </v-flex>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <IgTextField
                        :status="status"
                        :label="$t('address')"
                        v-model="entityLocal.address"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></IgTextField>
                    </v-flex>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <IgTextField
                        :status="status"
                        :label="$t('cp')"
                        v-model="entityLocal.cp"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></IgTextField>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="listStadiums"
                      :rules="[v => rules.vacio(v,'stadium')]"
                      :label="$t('select', {field :$tc('stadium') })"
                      persistent-hint
                      multiple
                      @change="searchStadium = ''"
                      :search-input.sync="searchStadium"
                      v-model="entityLocal.stadiumId"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          color="primary"
                          dark
                          :selected="data.selected"
                          close
                          @input="removeStadium(data.item)"
                          class="body-2 chip--select-multi"
                        >{{ data.item.text }}</v-chip>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex d-flex xs12>
                    <v-flex d-flex lg4 md4 sm12 xs12>
                      <v-autocomplete
                        :items="listCountries"
                        :rules="[v => rules.vacio(v,'country')]"
                        :label="$t('select', {field :$tc('country') })"
                        persistent-hint
                        v-model="entityLocal.country"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex d-flex lg4 md4 sm12 xs12>
                      <v-autocomplete
                        :disabled="entityLocal.country === ''"
                        :items="listProvinces"
                        :rules="[v => rules.vacio(v,'province')]"
                        :label="$t('select', {field :$tc('province') })"
                        persistent-hint
                        v-model="entityLocal.province"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex d-flex lg4 md4 sm12 xs12>
                      <v-autocomplete
                        :disabled="!entityLocal.province"
                        :items="listCities"
                        :rules="[v => rules.vacio(v,'town')]"
                        :label="$t('select', {field :$tc('town') })"
                        persistent-hint
                        v-model="entityLocal.city"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-autocomplete>
                    </v-flex>
                  </v-flex>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <v-autocomplete
                        :items="listLanguages"
                        :rules="[v => rules.vacio(v,'defaultLanguage')]"
                        :label="$t('select', {field :$tc('defaultLanguage') })"
                        persistent-hint
                        v-model="entityLocal.language"
                      ></v-autocomplete>
                    </v-flex>
                  </v-flex>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="clearForm()" color="warning" small>{{$t('reset')}}</v-btn>
                      <v-btn
                        @click="validarForm()"
                        :loading="loading"
                        color="success"
                        v-if="action === 'create'"
                        small
                      >{{$t('save')}}</v-btn>
                      <v-btn
                        @click="updateForm()"
                        :loading="loading"
                        color="secondary"
                        v-if="action === 'update'"
                        small
                      >{{$t('update')}}</v-btn>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'

export default {
  name: 'tabInformacion',
  mixins: [rules],
  props: {
    editExternal: {
      type: Boolean,
      required: false,
      default: true
    },
    action: {
      type: String,
      required: false,
      default: 'view'
    },
    status: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      searchStadium: '',
      entityLocal: {},
      loading: false
    }
  },
  mounted() {
    this.updateActions()
  },
  watch: {
    action: function(val) {
      // this.clearForm()
      this.updateActions()
    },
    entity: function(val) {
      this.clearForm()
      if (val) this.updateActions()
    },
    'entityLocal.country': function(val) {
      this.entityLocal.province = ''
    },
    'entityLocal.province': function(val) {
      this.entityLocal.city = ''
    }
  },
  computed: {
    ...mapState({
      entity: state => state.entities.entitySelected,
      listTeams: state => state.teams.listTeams,
      listUser: state => state.users.listaUsers,
      listLanguages: state => state.languages.listSelectLanguage,
      listStadiums: state => state.stadiums.listSelectStadiums
    }),
    ...mapGetters({
      listCountries: 'countries/selectList',
      listAllProvinces: 'provinces/selectList',
      listAllCities: 'cities/selectList'
    }),
    listProvinces() {
      if (!this.entityLocal.country) return []
      let me = this
      return this.listAllProvinces.filter(
        item => item.meta === me.entityLocal.country
      )
    },
    listCities() {
      if (!this.entityLocal.province) return []
      let me = this
      return this.listAllCities.filter(
        item => item.meta === me.entityLocal.province
      )
    },
    infoEntity() {
      if (!this.entity) {
        return []
      }
      const baseData = this.entity
      return [
        {
          field: this.$t('active'),
          data: baseData.active ? this.$t('yes') : this.$t('no')
        },
        {
          field: this.$t('client'),
          data: baseData.isCustomer ? this.$t('yes') : this.$t('no')
        },
        {
          field: this.$t('phone'),
          data: baseData.telf
        },
        {
          field: this.$t('email'),
          data: baseData.email
        },
        {
          field: this.$t('address'),
          data: baseData.address
        },
        {
          field: this.$t('cp'),
          data: baseData.cp
        },
        {
          field: this.$tc('stadium', 2),
          data: this.formatStadiums(baseData.stadiumId)
        },
        {
          field: this.$tc('country'),
          data: this.formatCountry(baseData.country)
        },
        {
          field: this.$tc('province'),
          data: this.formatProvince(baseData.province)
        },
        {
          field: this.$tc('town'),
          data: this.formatCity(baseData.town)
        },
        {
          field: 'Web',
          data: baseData.path
        },
        {
          field: this.$t('createdBy'),
          data: this.userFormat(baseData.createdBy)
        },
        {
          field: this.$t('createdAt'),
          data: this.dateFormat(baseData.createdAt)
        },
        {
          field: this.$t('defaultLanguage'),
          data: this.languageFormat(baseData.languageDefault)
        }
      ]
    },
    title() {
      if (this.action !== 'create') {
        return this.entity.name
      }
      return ''
    }
  },
  methods: {
    ...mapActions({
      setNew: 'entities/setCreateNew',
      setUpdate: 'entities/setUpdateEntity',
      setRemove: 'entities/setDeleteEntity'
    }),
    formatCountry(id) {
      const country = this.listCountries.find(item => item.value === id)
      return country ? country.text : ''
    },
    formatCity(id) {
      const city = this.listAllCities.find(item => item.value === id)
      return city ? city.text : ''
    },
    formatProvince(id) {
      const province = this.listAllProvinces.find(item => item.value === id)
      return province ? province.text : ''
    },
    formatStadiums(ids) {
      const stadiums = this.listStadiums.filter(item =>
        ids.includes(item.value)
      )
      return stadiums.map(item => item.text).join(', ')
    },
    updateActions() {
      if (this.action === 'update') {
        let me = this
        const baseData = me.entity
        me.entityLocal = {
          active: baseData.active,
          isCustomer: baseData.isCustomer,
          name: baseData.name,
          phone: baseData.telf,
          email: baseData.email,
          cp: baseData.cp,
          address: baseData.address,
          country: baseData.country,
          province: baseData.province,
          city: baseData.town,
          web: baseData.path,
          language: baseData.languageDefault,
          stadiumId: baseData.stadiumId
        }
        setTimeout(() => {
          me.entityLocal.province = baseData.province
        }, 50)
        setTimeout(() => {
          me.entityLocal.city = baseData.town
        }, 100)
      }
      if (this.action === 'create') {
        this.entityLocal = {
          active: false,
          isCustomer: false,
          name: '',
          phone: '',
          email: '',
          address: '',
          cp: '',
          country: '',
          province: '',
          city: '',
          web: '',
          language: '',
          stadiumId: []
        }
      }
    },
    dateFormat(date) {
      const newDate = new Date(date)
      return (
        newDate.getDate() +
        ' / ' +
        (newDate.getMonth() + 1) +
        ' / ' +
        newDate.getFullYear()
      )
    },
    userFormat(userId) {
      let result = this.listUser.find(item => item._id === userId)
      return result ? result.name : ''
    },
    languageFormat(languageId) {
      let result = this.listLanguages.find(item => item.value === languageId)
      return result ? result.text : ''
    },
    clearForm() {
      this.entityLocal = {
        active: false,
        isCustomer: false,
        name: '',
        phone: '',
        email: '',
        address: '',
        cp: '',
        country: '',
        province: '',
        city: '',
        web: '',
        language: '',
        stadiumId: []
      }
    },
    errorForm() {
      let error = false
      let message = []
      const formData = this.entityLocal
      if (!formData.name) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('name') }))
      }

      if (!formData.country) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('country') }))
      }

      if (!formData.province) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('province') }))
      }
      if (!formData.city) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('town') }))
      }
      if (!formData.language) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('language') }))
      }
      return {
        error,
        message
      }
    },
    createEntity() {
      const entity = this.entityLocal
      return {
        name: entity.name,
        active: entity.active,
        isCustomer: entity.isCustomer,
        telf: entity.phone,
        email: entity.email,
        address: entity.address,
        cp: entity.cp,
        countryId: entity.country,
        provinceId: entity.province,
        townId: entity.city,
        path: entity.web,
        languageDefault: entity.language,
        stadiumId: entity.stadiumId
      }
    },
    validarForm() {
      const error = this.errorForm()
      if (error.error) {
        queueToast(error.message)
        return
      }
      this.loading = true
      this.setNew(this.createEntity())
        .then(_ => this.$emit('close'))
        .finally(_ => (this.loading = false))
    },
    updateForm() {
      const error = this.errorForm()
      if (error.error) {
        queueToast(error.message)
        return
      }
      let entity = this.createEntity()
      entity._id = this.entity._id
      this.loading = true
      this.setUpdate(entity)
        .then(_ => this.$emit('close'))
        .finally(_ => (this.loading = false))
    },
    removeForm() {
      this.loading = true
      this.setRemove(this.entity._id)
        .then(_ => this.$emit('close'))
        .finally(_ => (this.loading = false))
    },
    removeStadium(item) {
      const index = this.entityLocal.stadiumId.indexOf(item.value)
      if (index >= 0) this.entityLocal.stadiumId.splice(index, 1)
    }
  }
}
</script>
